import React, { useState, useEffect } from 'react';

function CollapsibleSection({ title, children }) {
  // Default to true (open), but we will check screen size instantly
  const [isOpen, setIsOpen] = useState(true);

  useEffect(() => {
    // If screen is mobile-sized on load, collapse it automatically
    if (window.innerWidth <= 991) {
      setIsOpen(false);
    }
  }, []);

  return (
    <div style={{ borderBottom: "1px solid #333", marginBottom: "10px" }}>
      <button 
        onClick={() => setIsOpen(!isOpen)}
        style={{
          width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center",
          background: "transparent", border: "none", color: "#fff", padding: "15px 0",
          textTransform: "uppercase", fontWeight: "bold", cursor: "pointer", fontSize: "14px",
          textAlign: "left"
        }}
      >
        {title}
        <span style={{ 
            transform: isOpen ? "rotate(180deg)" : "rotate(0deg)", 
            transition: "transform 0.3s ease", 
            color: "#D5A678",
            fontSize: "12px"
        }}>
          ▼
        </span>
      </button>
      
      {/* The content wrapper with a smooth sliding animation */}
      <div style={{ 
        maxHeight: isOpen ? "2000px" : "0", 
        overflow: "hidden", 
        transition: "max-height 0.4s ease-in-out",
        opacity: isOpen ? 1 : 0
      }}>
        <div style={{ paddingBottom: "20px", color: "#aaa", fontSize: "14px", lineHeight: "1.6" }}>
          {children}
        </div>
      </div>
    </div>
  );
}

export default CollapsibleSection;